import { ElementType } from "../../../../../library-js/dom-tools/ElementType";
import { AudioEditorUIComponent } from "./AudioEditorUIComponent";

export class InspectorView extends AudioEditorUIComponent<Element>
{
  static readonly type = new ElementType( "inspector-view" );

  async initialize():Promise<void>
  {
    this._createElement( InspectorView.type );

    this.ui.appendChild( this );
    return Promise.resolve();
    
  }
}